module.exports = {"id":"199051","name":"Yohan Tavares","rating":"73","photo":"./data/images/photos/1/199051.png","club":{"name":"Vitoria Setúbal","logo":"./data/images/clubs/VitoriaSetubal.png"},"positions":["DC"],"photoFolderIndex":1}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/YohanTavares0.json
// module id = 4420
// module chunks = 0